(function (Global) {
    var MESSAGE_COOKIE_NAME = "_IWH";
    var CookieManager = function (config) {
        config = config || {}
        this.allServices = ['analytics', 'social', 'liveChat']; // OneSignal n'est pas listé car il est géré via la bannière. Cette clé est utilisé dans le cas où on clique sur le bouton "Accepter tous les cookies"
        this.cookieName = config.cookieName || MESSAGE_COOKIE_NAME;
    }

    CookieManager.prototype.approve = function (services) {
        var servicesB64 = Global.btoa(JSON.stringify(services));
        Global.Cookie.create(this.cookieName, servicesB64, 365);
        this.activate(services);
    }

    CookieManager.prototype.decline = function () {
        Global.Cookie.remove(this.cookieName);
    }

    CookieManager.prototype.activate = function (services) {
        $(document).trigger("CookieConsent", { services: services });
    }

    CookieManager.prototype.servicesActivate = function () {
        try {
            var servicesB64 = Global.Cookie.get(this.cookieName);
            if (!servicesB64 || servicesB64 === '' || servicesB64 === 'yes') return [];

            return JSON.parse(Global.atob(servicesB64));
        } catch (err) {
            console.error(err)
            return err;
        }
    }

    CookieManager.prototype.continueWithout = function () {
        this.approve([]);
    }

    Global.CookieManager = CookieManager;
}(window));